import Axios from "axios";
import { useEffect, useReducer } from "react";
import { apiDomain, systemCode, warName, xs_isMobile, xs_languageCode } from "..";
import { dataFetchReducer } from "./utils/dataFetchReducer";
import { parseStaticData } from "./parseStaticData";
import { getLSItemOrEmptyString } from './utils/getLSItemOrEmptyString';

export function useFetchStaticData() {
    const [state, dispatch] = useReducer(dataFetchReducer, {
        isLoading: true,
        isError: false,
    });
    
    useEffect(function() {
        let didCancel = false;

        const fetchData = async (url, params, callback) => {
            dispatch({ type: 'FETCH_INIT' });
            try {
                const result = await Axios.get(url, {params});
                if (!didCancel) {
                    callback(result.data);
                }
            } catch (error) {
                console.error('Errore ' + url + ': ' + error);
                if (!didCancel) {
                    dispatch({ type: 'FETCH_FAILURE' });
                }
            }
        };

        // If the LS keys are not present, delete signatures too so data is donwloaded again
        if (localStorage.getItem('xs_aggregate') == null) {
            localStorage.removeItem('xs_signature_aggregate')
        }
        if (localStorage.getItem('xs_macrogruppi') == null) {
            localStorage.removeItem('xs_signature_macrogruppi')
        }
        if (localStorage.getItem('xs_configuration') == null) {
            localStorage.removeItem('xs_signature_configuration')
        }
        if (localStorage.getItem('xs_labels') == null) {
            localStorage.removeItem('xs_signature_labels')
        }
        if (localStorage.getItem('xs_templates') == null) {
            localStorage.removeItem('xs_signature_templates')
        }

        let signatureAggregate = getLSItemOrEmptyString('xs_signature_aggregate');
        let signatureMacrogruppi = getLSItemOrEmptyString('xs_signature_macrogruppi');
        let signatureConfiguration = getLSItemOrEmptyString('xs_signature_configuration');
        let signatureLabels = getLSItemOrEmptyString('xs_signature_labels');
        let betTemplatesSignature = getLSItemOrEmptyString('xs_signature_templates');
        let localStorageVersion = getLSItemOrEmptyString('xs_localstorage_version');
        let isMobile = xs_isMobile;
        const url = `${apiDomain}/${warName}/getStaticData`;
        const params = {
            systemCode,
            lingua: xs_languageCode,
            hash: '',
            signatureAggregate,
            signatureMacrogruppi,
            signatureConfiguration,
            signatureLabels,
            betTemplatesSignature,
            localStorageVersion,
            isMobile
        };
        
        fetchData(url, params, function(response) {
        	parseStaticData(response);
            dispatch({ type: 'FETCH_SUCCESS' });
        });
        
        return () => {
            didCancel = true;
        };
    }, []);

    return [state, dispatch]
}
